/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Detail_RunningInputs */

const es_chat_tool_detail_running = /** @type {(inputs: Chat_Tool_Detail_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejecutando`)
};

const en_chat_tool_detail_running = /** @type {(inputs: Chat_Tool_Detail_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Running`)
};

/**
* | output |
* | --- |
* | "Running" |
*
* @param {Chat_Tool_Detail_RunningInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_tool_detail_running = /** @type {((inputs?: Chat_Tool_Detail_RunningInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Detail_RunningInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_tool_detail_running(inputs)
	return en_chat_tool_detail_running(inputs)
});
export { chat_tool_detail_running as "chat.tool_detail.running" }